import { useMobile } from "@/hooks/use-responsive";
import styles from "@/components/pages/home/components/voices/styles/voice-card-placeholder.module.scss";
import cardPlaceholder from "@/assets/animations/voice-card-placeholder.json";
import mobileCardPlaceholder from "@/assets/animations/mobile-voice-card-placeholder.json";
import LoaderBase from "@/components/common/base/loader-base";

const VoiceCardPlaceholder = () => {
  const { isMobile } = useMobile();

  const src = isMobile ? mobileCardPlaceholder : cardPlaceholder;

  return (
    <div className={styles.placeholder_wrapper}>
      <LoaderBase source={src} />
    </div>
  );
};

export default VoiceCardPlaceholder;
